import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { formatCurrency, formatNumber } from "pages/analytics/components/analyticsFormatters";
import { aggregateBySource } from "../utils/attributionDashboardUtils";

const SERIES = [
  { key: "contacts", label: "Contacts", color: "#4F46E5" },
  { key: "sales", label: "Sales", color: "#4CAF50" },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const revenue = payload[0]?.payload?.revenue ?? 0;
  return (
    <div className="bg-white p-3 border border-gray-200 shadow-sm rounded-md">
      <p className="text-sm font-medium text-gray-900 mb-1">{label}</p>
      {payload.map((entry) => (
        <p key={entry.dataKey} className="text-sm" style={{ color: entry.color }}>
          <span className="font-medium">{entry.name}:</span> {formatNumber(entry.value)}
        </p>
      ))}
      <p className="text-sm text-gray-700 mt-1">
        <span className="font-medium">Revenue:</span> {formatCurrency(revenue)}
      </p>
    </div>
  );
};

export default function AttributionDrilldownChart({ rows }) {
  const [isMobile, setIsMobile] = useState(false);
  const data = aggregateBySource(rows);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const chartHeight = isMobile ? 260 : 320;

  return (
    <div className={isMobile ? "overflow-x-auto" : ""}>
      <div style={{ minWidth: isMobile ? Math.max(data.length * 72, 320) : "100%", height: chartHeight }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
            <XAxis
              dataKey="source"
              tick={{ fontSize: isMobile ? 10 : 12, fill: "#6B7280" }}
              axisLine={{ stroke: "#E5E7EB" }}
              tickLine={{ stroke: "#E5E7EB" }}
              angle={isMobile ? -35 : 0}
              textAnchor={isMobile ? "end" : "middle"}
              height={isMobile ? 56 : 30}
            />
            <YAxis
              tickFormatter={(v) => formatNumber(v)}
              tick={{ fontSize: isMobile ? 10 : 12, fill: "#6B7280" }}
              axisLine={{ stroke: "#E5E7EB" }}
              tickLine={{ stroke: "#E5E7EB" }}
              width={isMobile ? 48 : 60}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            {SERIES.map(({ key, label, color }) => (
              <Bar key={key} dataKey={key} name={label} fill={color} radius={[4, 4, 0, 0]} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
